import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inner-modal" }
const _hoisted_2 = { class: "inner-modal inner-modal--CM" }
const _hoisted_3 = { class: "inner-modal--CM-body" }
const _hoisted_4 = { class: "modal-actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode()

import Cta from '../Cta.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
    categoryType: String,
    selection: Object,
    handleContinueSelection: Function,
    compatibilityModalMessage: String,
},
  setup(__props) {

const props = __props


const store = useStore();
const closeModal = async() => {
    await store.dispatch('closeModal');
};
const handleContinue = async() => {
    props.handleContinueSelection(props.selection, true);
    await store.dispatch('closeModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" <div class=\"inner-modal--header\">\r\n                    <h3></h3>\r\n                </div> "),
        _createElementVNode("p", null, _toDisplayString(__props.compatibilityModalMessage), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Cta, {
          type: "primary",
          label: "Continue",
          size: "lg",
          onOnClick: handleContinue
        }),
        _hoisted_5,
        _createVNode(Cta, {
          type: "outline",
          label: "Cancel",
          size: "lg",
          onOnClick: closeModal
        })
      ])
    ]),
    _createElementVNode("button", {
      onClick: closeModal,
      class: "inner-modal__close"
    }, "×")
  ]))
}
}

})